import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// The live-update WebSocket is either actively connected, in the middle of
// (re)connecting, or down. The app bar reads this to render a status circle.
export type ConnectionStatus = 'connecting' | 'connected' | 'disconnected';

export interface ConnectionStatusState {
    status: ConnectionStatus;
}

const initialState: ConnectionStatusState = {
    // `lazy: true` means the socket only opens once the first subscription
    // mounts, so we start in "connecting" rather than "connected".
    status: 'connecting',
};

export const connectionStatusSlice = createSlice({
    name: 'connectionStatus',
    initialState,
    reducers: {
        setConnectionStatus: (
            state,
            action: PayloadAction<ConnectionStatus>,
        ) => {
            state.status = action.payload;
        },
    },
});

export const { setConnectionStatus } = connectionStatusSlice.actions;

export default connectionStatusSlice.reducer;
